import {appLicenceService} from "../api/AppLicenceService";
import {isRunningInDevMode} from "navigation-common/firebase-config";

export const hasCqlFeature = async () => {
    if (isRunningInDevMode()) {
        return true;
    }
    const appVersion = await appLicenceService.getAppVersion();
    return compareVersions(appVersion, '1.2.15-AC') >= 0;
}


function compareVersions(v1: string, v2: string): number {
    const sanitizeVersion = (version: string) => version.split('-')[0];
    const parseVersion = (version: string) => sanitizeVersion(version).split('.').map(Number);

    const v1Parts = parseVersion(v1);
    const v2Parts = parseVersion(v2);

    const maxLength = Math.max(v1Parts.length, v2Parts.length);

    for (let i = 0; i < maxLength; i++) {
        const num1 = v1Parts[i] || 0;
        const num2 = v2Parts[i] || 0;

        if (num1 > num2) return 1;
        if (num1 < num2) return -1;
    }

    return 0;
}
